import { bl_svc_request_action_RowCLass } from '../../../dbschema/bl_svc_request_action.model';
import { BaseContainerModel } from '../../base-container.model';


export class ServiceRequestActionContainerModel extends BaseContainerModel {
  bl_svc_request_action: bl_svc_request_action_RowCLass = new bl_svc_request_action_RowCLass();
}
